module.exports = __webpack_public_path__ + "img/music-purple.011a4c23.svg";